import axiosvl from "../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {

    data() {
        return {
            selectedyear: '',
            selectedmake: '',
            selectedmodel: '',
            selectedengine: '',
            years: [],
            makes: [],
            models: [],
            engines: [],
            vinnumber: '',
            searchvalid: null,
            catpn: '',
            vehicleloading: false,
            vehiclemessages: [],
            vehiclewasselected: false, // set this to true when a vehicle is selected to make the BaseSelectVehicle component emit a close event
        }
    },

    methods: {
        getYears() {
            this.years = [];
            this.selectedmake = '', this.selectedmodel = '', this.selectedengine = '';
            this.catpn = this.$store.getters['storeConfigID'];

            const vehicle_years_uri = this.$store.getters['api/vehicle_years_uri'];
            axiosvl.post(vehicle_years_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {
                                "value": this.$store.getters.customer
                            },
                            "CATPN": {
                                "value": this.catpn
                            }
                        }           
                    }
                }
            )
            .then((response) => {
                const results = [];
                const fields = response.data.webroutine.fields
                if (fields.RESULTCOD.value === 'OK') {
                    for (const key in response.data.webroutine.lists.YEARSD.entries) {
                        const obj = response.data.webroutine.lists.YEARSD.entries[key];
                        results.push({
                            year: obj.QYEAR,
                        });
                    }
                    this.years = results;
                }
            })
            .catch((error) => {
                console.log("error -HeaderSearch" + error);
            });
        },

        getMakes() {
            this.makes = [];
            this.selectedmake = '', this.selectedmodel = '', this.selectedengine = '';
            if (this.selectedyear != '') {
                const vehicle_makes_uri = (this.storeCatalog === 'WHI') ? this.$store.getters['api/vehicle_makes_uri'] : this.$store.getters['api/vehicle_yrmodel_uri'];
                axiosvl.post(vehicle_makes_uri, {
                        "webroutine": {
                            "context": {
                                "session-key-method": "hidden"
                            },
                            "fields": {
                                "EHCUST": {
                                    "value": this.$store.getters.customer
                                },
                                "CATPN": {
                                    "value": this.catpn
                                },
                                "QYEAR": {
                                    "value": this.selectedyear
                                }
                            }           
                        }
                    }
                )
                .then((response) => {
                    const results = [];
                    const fields = response.data.webroutine.fields
                    if (fields.RESULTCOD.value === 'OK') {
                        if(this.$store.getters['storeCatalog'].toUpperCase() == 'WHI'){
                            for (const key in response.data.webroutine.lists.MAKESD.entries) {
                                const obj = response.data.webroutine.lists.MAKESD.entries[key];
                                results.push({
                                    make: obj.QMAKE,
                                    desc: obj.QMKDSC
                                });
                                this.makes = results;
                            }
                        } else {
                            for (const key in response.data.webroutine.lists.MODELSD.entries) {
                                const obj = response.data.webroutine.lists.MODELSD.entries[key];
                                results.push({
                                    model: obj.QMODSC,
                                    make : obj.QMKDSC,
                                    desc: obj.QMODSC,
                                });
                                this.makes = results;
                            }
                            this.selectedmake = 'NA';
                            this.makes = [];
                            this.models = results;
                        }
                    }
                })
                .catch((error) => {
                    console.log("error - " + error);
                });
            }
        },

        async getModels() {
            this.models = [];
            this.selectedmodel = '', this.selectedengine = '';
            const vehicle_model_uri = this.$store.getters['api/vehicle_model_uri'];
            
            let param = {};
            if(this.$store.getters['storeCatalog'].toUpperCase() == 'WHI'){
                param = {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {
                                "value": this.$store.getters.customer
                            },
                            "CATPN": {
                                "value": this.catpn
                            },
                            "QYEAR": {
                                "value": this.selectedyear
                            },
                            "QMAKE": {
                                "value": this.selectedmake
                            }
                        }           
                    }
                };
            }else{
                param = {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {
                                "value": this.$store.getters.customer
                            },
                            "CATPN": {
                                "value": this.catpn
                            },
                            "QYEAR": {
                                "value": this.selectedyear
                            },
                            "QMKDSC": {
                                "value": this.selectedmake
                            }
                        }           
                    }
                };
            }
            
            if (this.selectedmake != '') {
                // const url = "/D15PGMLIB/lansaweb?w=whi&r=models&vlweb=1&part=" + this.$store.getters['system/erppartition'] + "&lang=" + this.$store.getters['system/language'] + "&_T=1611072351543";
                axiosvl.post(vehicle_model_uri, param)
                .then((response) => {
                    const results = [];
                    const fields = response.data.webroutine.fields
                    if (fields.RESULTCOD.value === 'OK') {
                        for (const key in response.data.webroutine.lists.MODELSD.entries) {
                            const obj = response.data.webroutine.lists.MODELSD.entries[key];

                            if(this.$store.getters['storeCatalog'].toUpperCase() == 'WHI'){
                                results.push({
                                    model: obj.QMODEL,
                                    desc: obj.QMODSC
                                });
                            }else{
                                results.push({
                                    model: obj.QMODSC,
                                    desc: obj.QMODSC
                                });
                            }
                        }
                        this.models = results;
                    }
                })
                .catch((error) => {
                    console.log("error - " + error);
                });
            }
        },

        getEngines() { 
            this.engines = [];
            this.selectedengine = '';
            if (this.$store.getters['storeCatalog'].toUpperCase() == 'PARTSLINK') {
                const mods = this.models.find(m => m.model == this.selectedmodel);
                this.selectedmake = mods.make;
                return;
            }

            if (this.selectedModel != '') {
                const vehicle_engine_uri = this.$store.getters['api/vehicle_engine_uri'];
                // const url = "/D15PGMLIB/lansaweb?w=whi&r=engines&vlweb=1&part=" + this.$store.getters['system/erppartition'] + "&lang=" + this.$store.getters['system/language'] + "&_T=1611072351543";
                axiosvl.post(vehicle_engine_uri, 
                      {
                        "webroutine": {
                            "context": {
                                "session-key-method": "hidden"
                            },
                            "fields": {
                                "EHCUST": {
                                    "value": this.$store.getters.customer
                                },
                                "CATPN": {
                                    "value": this.catpn
                                },
                                "QYEAR": {
                                    "value": this.selectedyear
                                },
                                "QMAKE": {
                                    "value": this.selectedmake
                                },
                                "QMODEL": {
                                    "value": this.selectedmodel
                                }
                            }           
                        }
                    }
                )
                .then((response) => {
                    const results = [];
                    const fields = response.data.webroutine.fields
                    if (fields.RESULTCOD.value === 'OK') {
                        for (const key in response.data.webroutine.lists.ENGINESD.entries) {
                            const obj = response.data.webroutine.lists.ENGINESD.entries[key];
                            results.push({
                                engine: obj.QCARCD,
                                desc: obj.QENDSC
                            });
                        }
                        this.engines = results;
                    }
                })
                .catch((error) => {
                    console.log("error - " + error);
                });
            }
        },

        clearData() {
            this.selectedyear = '', this.selectedmake = '', this.selectedmodel = '', this.selectedengine = '';
            this.years = [], this.makes = [], this.models = [], this.engines = [];
        },

        newVehicleId() {
            let vehicleid = this.$store.getters['vehicle/selectedvehicle'];

            if (vehicleid === undefined) {
                vehicleid = 0
            }

            vehicleid++;
            return vehicleid;
        },

        searchParts() {
            this.vehiclemessages = [];
            if ((this.vinnumber === null) || (this.vinnumber === '')) {
              this.searchByDropdowns();
            } else {
                const sfCatalog = this.$store.getters['storeCatalog'];
                if(sfCatalog == 'WHI'){
                    this.searchByVin();
                }else{
                    this.$router.push("/search-results/keyword/" + this.vinnumber);
                }
            }
        },

        searchByDropdowns() {
            console.log('searchByDropdowns');
            let searchvalid = true;
            let makedesc = '';

            if (this.$store.getters['storeCatalog'].toUpperCase() == 'WHI') {
                if (this.selectedyear === '' || this.selectedmake === '' || this.selectedmodel === '' || this.selectedengine === '') {
                    searchvalid = false;
                    this.vehiclemessages.push('Please select values for Year/Make/Model/Engine to conduct your search.');
                }
            } else {
                if (this.selectedyear === '' || this.selectedmake === '' || this.selectedmodel === '') {
                    searchvalid = false;
                    this.vehiclemessages.push('Please select values for Year/Make/Model to conduct your search.');
                }
            }
            console.log(searchvalid);
            
            if (searchvalid) {
                this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": this.newVehicleId() });
                this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": this.selectedyear });
                this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": this.selectedmodel, "desc": this.models.find(model => model.model === this.selectedmodel).desc });
                const catpn = this.$store.getters['storeConfigID'];
                let enginedesc = '';
                if (this.$store.getters['storeCatalog'].toUpperCase() == 'WHI') {
                    makedesc = this.makes.find(make => make.make === this.selectedmake).desc;
                    this.$store.dispatch("vehicle/setSelectedEngine", { "selectedengine": this.selectedengine, "desc": this.engines.find(engine => engine.engine === this.selectedengine).desc });
                    this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": this.selectedmake, "desc": makedesc });
                    enginedesc = this.engines.find(engine => engine.engine === this.selectedengine).desc

                }else{
                    makedesc = this.selectedmake;
                    this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": this.selectedmake, "desc": this.selectedmake });
                }

                let requestdata = {
                    "EHCUST": {"value": this.$store.getters.customer},
                    "CATPN": {"value": catpn},
                    "QYEAR": {"value": this.selectedyear},
                    "QMAKE": {"value": this.selectedmake},
                    "QMKDSC": {"value": makedesc },
                    "QMODEL": {"value": this.selectedmodel},
                    "QMODSC": {"value": this.models.find(model => model.model === this.selectedmodel).desc },
                    "QCARCD": {"value": this.selectedengine},
                    "QENDSC": {"value": enginedesc}
                };

                this.saveSelectedVehicle(requestdata);

                // const selectedcat = this.$store.getters['vehicle/selectedcategories'];
                this.vehiclewasselected = true;
                console.log('vehiclewasselected = ' + this.vehiclewasselected);

                // @TODO: change, search complete
                // if(selectedcat.length !== 0){
                //     this.$router.push("/search-results");
                // }else{
                //     this.$router.push("/select-parts-drilldown");
                // }

                this.$emit('selectedVehicleComplete');
            }
        },

        searchByVin() {
            console.log('searchByVin');
            const vin_uri = this.$store.getters['api/vin_uri'];
            const sfCatalog = this.$store.getters['storeCatalog'];
            const catpn = this.$store.getters['storeConfigID'];

            // let catpn = null;
            // if (sfCatalog.toUpperCase() == 'WHI'){
            //     catpn = '003';
            // } else {
            //     catpn = '002';
            // }

            const params = {
                webroutine: {
                    context: {
                        "session-key-method": "hidden",
                    },
                    fields: {
                        EHCUST: {value: this.$store.getters.customer},
                        CATPN: {value: catpn},
                        QVIN: {value: this.vinnumber},
                    },
                },
            };

            this.vehicleloading = true;

            axiosvl.post(vin_uri, params)
            .then((response) => {
                this.vehicleloading = false;
                const fieldsData = response.data.webroutine.fields;
                const catpn = this.$store.getters['storeConfigID'];
                if (fieldsData.RESULTCOD.value === 'OK'){
                    this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": this.newVehicleId() });
                    this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": fieldsData.QYEAR.value });
                    this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": fieldsData.QMAKE.value, "desc": fieldsData.QMKDSC.value });
                    this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": fieldsData.QMODEL.value, "desc": fieldsData.QMODSC.value});

                    // if the store catalog is WHI
                    if (sfCatalog.toUpperCase() == 'WHI'){
                        this.$store.dispatch("vehicle/setSelectedEngine", { "selectedengine": fieldsData.QCARCD.value, "desc": fieldsData.QENDSC.value });
                    }

                    let requestdata = {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "CATPN": {"value": catpn},
                        "QYEAR": {"value": fieldsData.QYEAR.value },
                        "QMAKE": {"value": fieldsData.QMAKE.value },
                        "QMKDSC": {"value": fieldsData.QMKDSC.value },
                        "QMODEL": {"value": fieldsData.QMODEL.value },
                        "QMODSC": {"value": fieldsData.QMODSC.value },
                        "QCARCD": {"value": fieldsData.QCARCD.value},
                        "QENDSC": {"value": fieldsData.QENDSC.value }
                    };

                    this.saveSelectedVehicle(requestdata);
                    this.vehiclewasselected = true;
                    this.$router.push("/select-parts-drilldown");
                } else {
                    this.vehiclemessages.push('Please enter a valid VIN number.');
                }
            
            });
        },

        saveSelectedVehicle(requestdata) {
            if (this.$store.getters.userIsAuthenticated) {
                axiosvl.post(this.$store.getters['api/add_saved_vehicle_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": requestdata
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields
          
                    if (fields.RESULTCOD.value === 'OK') {
                      this.$store.dispatch("vehicle/setNewSavedVehicleAdded", true);
                    }
          
                })
                .catch((error) => {
                  this.isloading = false;
                    console.log("error - " + error);
                });
            }
           
        }
    },
        
    computed: {
        ...mapGetters([
            "storeCatalog"
        ]),

        selected_year() {
            const year = this.$store.getters['vehicle/selectedyear'];
            return year;
        },

        selected_make() {
            const make = this.$store.getters['vehicle/selectedmake'];
            return make;
        },

        selected_model() {
            const model = this.$store.getters['vehicle/selectedmodel'];
            return model;
        },

        selected_engine() {
            const engine = this.$store.getters['vehicle/selectedengine'];
            return engine;
        },
    }
};
  